export interface PdfPreview {
  url: string;
  fileName: string;
}

interface PdfPreviewModalProps {
  preview: PdfPreview | null;
  onClose: () => void;
}

const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
  preview,
  onClose,
}) => {
  if (!preview) {
    return null;
  }

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1050,
      }}
    >
      <div
        className="modal-dialog modal-xl"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          margin: 0,
          width: "95vw",
          maxWidth: "1200px",
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Vista previa: {preview.fileName}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Cerrar"
            ></button>
          </div>
          <div className="modal-body" style={{ height: "80vh", padding: 0 }}>
            <iframe
              src={preview.url}
              title={`Vista previa de ${preview.fileName}`}
              style={{
                width: "100%",
                height: "100%",
                border: 0,
              }}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfPreviewModal;
